var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaderboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16.5C19.75 16.6989 19.671 16.8897 19.5303 17.0303C19.3897 17.171 19.1989 17.25 19 17.25H1C0.801088 17.25 0.610322 17.171 0.46967 17.0303C0.329018 16.8897 0.25 16.6989 0.25 16.5V1.5C0.25 1.30109 0.329018 1.11032 0.46967 0.96967C0.610322 0.829018 0.801088 0.75 1 0.75C1.19891 0.75 1.38968 0.829018 1.53033 0.96967C1.67098 1.11032 1.75 1.30109 1.75 1.5V10.3472L6.50594 6.1875C6.63536 6.07421 6.79978 6.00885 6.97165 6.00236C7.14353 5.99587 7.31241 6.04866 7.45 6.15188L12.9634 10.2872L18.5059 5.4375C18.5786 5.36556 18.6652 5.30925 18.7605 5.27201C18.8557 5.23478 18.9575 5.21741 19.0597 5.22097C19.1619 5.22454 19.2623 5.24896 19.3547 5.29275C19.4471 5.33653 19.5296 5.39875 19.5971 5.47558C19.6645 5.5524 19.7156 5.64222 19.7471 5.7395C19.7786 5.83678 19.7899 5.93948 19.7802 6.04128C19.7706 6.14307 19.7402 6.24182 19.691 6.33146C19.6418 6.42109 19.5748 6.49972 19.4941 6.5625L13.4941 11.8125C13.3646 11.9258 13.2002 11.9912 13.0283 11.9976C12.8565 12.0041 12.6876 11.9513 12.55 11.8481L7.03656 7.71469L1.75 12.3403V15.75H19C19.1989 15.75 19.3897 15.829 19.5303 15.9697C19.671 16.1103 19.75 16.3011 19.75 16.5Z",
    fill: "#0066CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.14bf9d8126ef6d42d5ac0cf4117499ce.svg";
export { ForwardRef as ReactComponent };